import { BROWSER_SESSION, BUILDER_SESSION } from '~/types'

export default defineNuxtPlugin(() => {
  const builderSession = useBuilderSessionStore()
  const browserSession = useBrowserSessionStore()

  const bugsnag = useBugsnag()

  // Skip if no bugsnag key
  if (!bugsnag.addOnError)
    return

  bugsnag.addOnError((event) => {
    const data = builderSession.sessionData || browserSession.sessionData
    if (data) {
      event.addMetadata('session', {
        session_type: builderSession.sessionData ? BUILDER_SESSION : BROWSER_SESSION,
        session_id: data.id,
        session_status: data.status,
      })
    }
  })
})
